import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { MD5UtilService } from './MD5Util.service';
@Injectable({
  providedIn: 'root'
})
export class WalletService {
  loggedInSender = new BehaviorSubject('');
      
      constructor(private http: HttpClient,private md5Util:MD5UtilService) { }


  getBankList(){
    let headers = new HttpHeaders();
    headers = headers.append('apikey', environment.api_key);
  
    return this.http.get(`${environment.walletUrl}/api/get/all/bank/aeps`,{headers:headers})
  }
  getBankListofYM(){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.youmudraUrl}/v1/getBankDetail`,{headers:headers})
  }
  getBankListofYM2(){
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(`${environment.validate_url}/ym/retailor/getdepositbank`,{headers:headers})
  }
  RequestMoneywithUpload(
    email,
    uacid,
    deposite_file_doc,
    unique_Nmae,
    amount,
    bank,
    txnref,
    remarks
  ) {
    console.log(this.md5Util.Decrypt(localStorage.getItem("retailorYmid")));
    const formData = new FormData();
    formData.append("email", email);
    formData.append("uacid", uacid);
    formData.append("deposite_slip", deposite_file_doc);
    formData.append("amount", amount);
    formData.append("bank", bank);
    formData.append("ym_id", this.md5Util.Decrypt(localStorage.getItem("retailorYmid")));
    formData.append("ym_secret", this.md5Util.Decrypt(localStorage.getItem("retailorYmSecret")));
    formData.append("txnreferenceNo", txnref);
    formData.append("remarks", remarks);
    formData.append("unique_name",localStorage.getItem("uniqueName"));
    formData.append('requester_type',"Retailer")


    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.post(
      `${environment.youmudraUrl}/v1/user/walletTopupReq`,
      formData,{headers:headers}
    );
  }
  RequestMoneywithUpload2(
    amount,
    proof,
    remarks,
    redisbank,
    ymbank,
    referance  ) {
    console.log(this.md5Util.Decrypt(localStorage.getItem("retailorYmid")));
    const formData = new FormData();
    formData.append("amount", amount);
    formData.append("proof", proof);
    formData.append("remarks", remarks);
    formData.append("redisbank", redisbank);
    formData.append("ymbank", ymbank);
    formData.append("referance", referance);




    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.post(
      `${environment.validate_url}/ym/retailer/create/deposit`,
      formData,{headers:headers}
    );
  }
  createCMS(form:any,lat,long){
    const body={
      amount: form.amountTowithdrawl,
      latitude: lat,
      longitude: long,
      mobileNumber: form.mobile_no
    }
    
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));
    return this.http.post(
      `${environment.validate_url}/ym/cms/retailer/generate/url`,
      body,{headers:headers}
    );

  }
  createAirtelCMS(lat,long){
    const body={
      refid: '',
      latitude: lat,
      longitude: long,
    }
    
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));
    return this.http.post(
      `${environment.validate_url}/ym/cms/paysprint/init`,
      body,{headers:headers}
    );

  }

  getWalletRechargeStatus(status){
    let headers = new HttpHeaders();
    headers = headers.append("Authorization",localStorage.getItem('wallet-token'));

    return this.http.get(
      `${environment.youmudraUrl}/v1/user/getRetailerWalletTopUp/${status}`,{headers:headers})
      
  }
  getWalletRechargeStatus2(status){
    let headers = new HttpHeaders();
    headers = headers.append("authToken",localStorage.getItem('wallet-token'));

    return this.http.get(
      `${environment.validate_url}/ym/retailer/deposit/get?status=${status}`,{headers:headers})
      
  }
  getMAtmDevice(){

    let headers = new HttpHeaders();
    headers = headers.append("Authtoken",localStorage.getItem('wallet-token'));
    return this.http.get(`${environment.walletUrl}/ym/retailer/get/product`,{headers:headers})
  }
  buyProduct(productId:any){

    let headers = new HttpHeaders();
    headers = headers.append("Authtoken",localStorage.getItem('wallet-token'));
    return this.http.get(`${environment.walletUrl}/ym/retailer/buy/product?productId=${productId}`,{headers:headers})
  }
  
}
